import * as moment from 'moment-timezone';
import { createAction, props } from '@ngrx/store';
import { PayformStatusCd } from '@xpo-ltl/sdk-common';
import { PayformsFilterState } from '../app.state';
import { PayformsFilterDateTypes } from '../../enums/date-type.enum';

interface SetPayformsFilterStateProps {
  filter: Partial<PayformsFilterState>;
}

interface SetPayformsFilterDateProps {
  dateToSet: PayformsFilterDateTypes;
  newDate: moment.Moment;
}

interface SetPayformsFilterSICProps {
  sicCd: string;
}

interface RemovePayformsFilterStatusProps {
  status: PayformStatusCd;
}

export const setPayformsFilterStateAction = createAction('[Payforms Filter] Set filter state', props<SetPayformsFilterStateProps>());

export const setPayformsFilterDateAction = createAction('[Payforms Filter] Set date', props<SetPayformsFilterDateProps>());

export const setPayformsFilterSicAction = createAction('[Payforms Filter] Set SIC', props<SetPayformsFilterSICProps>());

export const removePayformsFilterStatusAction = createAction('[Payforms Filter] Remove status', props<RemovePayformsFilterStatusProps>());

export const clearPayformsFilterAction = createAction('[Payforms Filter] Clear filters (excluding SIC)');
